import React from "react";
import "./SettingsShell.scss";

const SettingsShell = ({ children }) => <div className="settings-shell">{children}</div>;

export default SettingsShell;
